<template>
	<b-tooltip 
		:target="target" 
		:triggers="triggers"
		:variant="variant"
		:placement="placement">

		{{primaryMessage}}

		<span v-if="!$auth.loading && !$auth.isAuthenticated">
			<b-link to="/gallery/personal">Sign in</b-link> or 
			
			<!-- 
				20201019 -- ZWS -- Should likely find a way use a router object with the authGuard
				instead of relying on a path.
			-->

			<b-link to="/profile/subscription">upgrade</b-link>.
		</span>

		<span v-else>
			<b-link :to="{name: 'profile', params: {section: 'subscription'}}">Upgrade now</b-link>.
		</span>
	
	</b-tooltip>
</template>

<script>

import genericOps from '@/mixins/genericOps.js'

export default {
	props: {
		placement: {
			type: String,
		},
		primaryMessage: {
			type: String,
			default: "This is a premium feature.  "
		},
		target: {
			type: String,
		},
		triggers: {
			type: String,
		},
		variant: {
			type: String,
		}
	},
	data() {
		return {
		}
	}

}
</script>